// if (process.env.MODE_ENV === 'production'){
//     baseUrl = 'http://localhost:3000'
// }else{
//     baseUrl = 'http://localhost:3000'
// }


// export const apiHost = 'http://localhost:1004';
export const apiHost = 'https://lims.accugenelab.com:1004';
// export const apiHost = 'http://192.168.10.8:3030';
// export const apiHost = 'http://lims.accugenelab.com:3010';
export const secretKey = 'accugene';
// export const apiHost = 'http://192.168.30.130:3000';
// export const apiHost = 'https://lims.accugenelab.co.kr:1004'
// export const apiHost = 'https://lims.accugenelab.com:1004'



// WEBPACK FOOTER //
// ./src/config/config.js